import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import AddUserLayer from '../components/AddUserLayer'

const AddUserPage = () => {
  return (
    <>
    <Breadcrumb title={"Add Customer"}/>

    <AddUserLayer/>
    </>
  )
}

export default AddUserPage